import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITrade } from "../interface/trade/ITrade";
import { IUpdateTradeAddress } from "src/pages/contingency/trade-maintenance/EditTrade/EditAddressComponent/IUpdateTradeAddress";
import { IUpdateTradeBank } from "src/pages/contingency/trade-maintenance/EditTrade/EditBankInfoComponent/IUpdateTradeBank";
import { generateQueryString } from "src/util/helper";
import { ITradeOwner } from "../interface/trade/Owner/ITradeOwner";

enum TradeServiceEnum {
  updateTradePricingFromContingency = "/update-trade-pricing-from-contingency",
  updateTradeOwnerFromContingency = "/owner",
  updateTradeAddressFromContingency = "/address",
  updateTradeSpouseFromContingency = "/spouse",
  updateTradeBankInfoFromContingency = "/bank", 
  updateTradeLawyerFromContingency = "/update-trade-lawyer-from-contingency",
  requestCessionContractSignatureContingency = "/request-cession-contract-signature-contingency",
  updateTicketLawFirmContingency = "/update-trade-law-firm-from-contingency"
}

export default class TradeContingencyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/contingency");
  }
  public postUpdateTradeOwnerFromContingency = async (request: ITradeOwner): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradeOwnerFromContingency, request);
  public postUpdateTradeAddressFromContingency = async (request: IUpdateTradeAddress): Promise<ITrade> =>
    await this.POST(TradeServiceEnum.updateTradeAddressFromContingency, request);
  public postUpdateTradeBankInfoFromContingency = async (request: IUpdateTradeBank): Promise<ITrade> =>
    await this.POST(TradeServiceEnum.updateTradeBankInfoFromContingency, request);
  public postUpdateTradePricingFromContingency = async (trade): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradePricingFromContingency, trade);
  public postUpdateTradeLawyerFromContingency = async (trade): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradeLawyerFromContingency, trade);
  public putRequestCessionContractSignatureContingency = async (tradeId: number) =>
    await this.PUT(`${TradeServiceEnum.requestCessionContractSignatureContingency}${generateQueryString({ tradeId })}`, tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/TradeContingency.service.ts